import { render, staticRenderFns } from "./InformationsHorse.vue?vue&type=template&id=b7f0b558&"
import script from "./InformationsHorse.vue?vue&type=script&lang=js&"
export * from "./InformationsHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports